import React from 'react';
import PropTypes from 'prop-types';

import { TweenLite, Sine } from 'gsap/all';
import { Transition } from 'react-transition-group';


const B13QuickLinksTopDefault = (props) => {
	const {
		timeout,
		active,
		callbacks,
		children,
		collapse,
		back,
	} = props;

	const animationTimeout = timeout / 1000;

	const onEnter = (node, isAppearing) => {
		// console.log('[On Enter]', node, ' :: ', isAppearing);
		if (collapse) {
			callbacks.setContainerHeight(node);
			return;
		}
		callbacks.animateHeight(node);
	};

	const onEntering = (node, isAppearing) => {
		// console.log('[On Entering]', node, ' :: ', isAppearing);
		if (collapse) {
			callbacks.animateContainerHeight(node, true);
		}
	};

	const onEntered = (node, isAppearing) => {
		// console.log('[On Entered]', node, ' :: ', isAppearing);
	};

	const onExit = (node) => {
		const { width } = node.getBoundingClientRect();
		node.style.width = `${width}px`;
		node.style.position = 'absolute';
		node.style.top = '0';
		node.style.left = '0';

		if (collapse) {
			return;
		}

		callbacks.setGroupHeight(node);
		// console.log('[On Exit]', node);
	};

	const onExiting = (node) => {
		// console.log('[On Exiting]', node);
		if (collapse) {
			callbacks.animateContainerHeight(node, false);
		}
	};

	const onExited = (node) => {
		// console.log('[On Exited]', node);
	};

	const onEnd = (node, done) => {
		// console.log('[On End]', node);
		const percent = 200;
		const animateIn = back ? -Math.abs(percent) : percent;
		const animateOut = back ? percent : -Math.abs(percent);

		TweenLite.fromTo(
			node,
			animationTimeout,
			{
				xPercent: active ? animateIn : 0,
				ease: Sine.easeIn,
			},
			{
				xPercent: active ? 0 : animateOut,
				ease: Sine.easeOut,
				onComplete: done,
			},
		);
	};

	return (
		<Transition
			timeout={timeout}
			mountOnEnter
			unmountOnExit
			appear={false}
			in={active}
			onEnter={onEnter}
			onEntering={onEntering}
			onEntered={onEntered}
			onExit={onExit}
			onExiting={onExiting}
			onExited={onExited}
			addEndListener={onEnd}
		>
			{ children }
		</Transition>
	);
};

B13QuickLinksTopDefault.propTypes = {
	timeout: PropTypes.number.isRequired,
	active: PropTypes.bool.isRequired,
	callbacks: PropTypes.shape({}),
	children: PropTypes.shape({}),
	collapse: PropTypes.bool,
	back: PropTypes.bool,
};

B13QuickLinksTopDefault.defaultProps = {
	callbacks: {},
	children: {},
	collapse: false,
	back: false,
};

export default B13QuickLinksTopDefault;
